import { render } from "./CurrentDateTime.vue?vue&type=template&id=74966c1f&scoped=true"
import script from "./CurrentDateTime.vue?vue&type=script&lang=js"
export * from "./CurrentDateTime.vue?vue&type=script&lang=js"

import "./CurrentDateTime.vue?vue&type=style&index=0&id=74966c1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74966c1f"]])

export default __exports__